import { MText } from '@/styles/mobilePageStyles';
import { View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider';
import { CButton } from '@app/components/Common';
import { COLORS } from '@app/constants';
import { useMyProfile } from '@app/hooks/user/myprofile';
import { IconCopy } from '@tabler/icons-react';
import CIUtils from '@utils/ciutils';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ChangeUsername from './ChangeUsername';
import { Col, Upload } from 'antd';
import { Row } from 'antd';
import API from '@/utils/api';
import { useToken } from '@/app/hooks/auth/token';
import styled from 'styled-components';
import { LoadingOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { USERINFO, VITE_APP_API_MEDIA_URL } from '@/app/constants/APIKEYS';

const ProfileEditContainer = () => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const { data: myinfo } = useMyProfile();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<any>(myinfo?.profileimage || null);
  const { token } = useToken();

  // useEffect(() => {
  //   setImageUrl(myinfo?.profileimage);
  // }, []);

  const handleUploadChange = async (info) => {
    if (loading) return;
    setLoading(true);

    try {
      const response = await API.post('/upload/presigned-url', token, {
        usage: 'avatar',
        fileExtension: info?.file?.type === 'image/jpeg' ? 'jpg' : 'png',
      });

      if (response.success) {
        const fileUrl = response.result.url;
        const resPatchUrl = await fetch(fileUrl, {
          method: 'PUT',
          body: info?.file?.originFileObj,
          headers: { 'Content-Type': info?.file?.type },
        });

        if (resPatchUrl.ok) {
          const imageUrl = `${VITE_APP_API_MEDIA_URL}/${response.result.key}`;
          const resCheck = await fetch(imageUrl);
          if (resCheck.ok) {
            setImageUrl(response.result.key);

            const res = await API.put(USERINFO, token + '', {
              profileimage: response.result.key,
            });

            if (res?.result?.success) {
              message.success(t('profileImageUpdated'));
            } else {
              message.error(t('profileImageUpdateFailed'));
            }
          } else {
            message.error(t('imageUploadFailed'));
          }
        }
      }
    } catch (error) {
      message.error(t('imageUploadFailed'));
    } finally {
      setLoading(false);
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error(t('You can only upload JPG/PNG file!'));
    }
    const isLt10M = file.size / 1024 / 1024 <= 10;
    if (!isLt10M) {
      message.error(t('Image must be 10MB or smaller!'));
    }
    return isJpgOrPng && isLt10M;
  };

  const uploadButton = (
    <UploadButton type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t('avatar')}
      </div>
    </UploadButton>
  );

  return (
    <View
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      {/*<ProfileImageSection />*/}
      <ChangeUsername />
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          marginTop: 30,
          background: theme.COLORS.PrimaryInputBg,
          border: `1px solid ${theme.COLORS.PrimaryInputBorder}`,
          padding: `8px 12px`,
          borderRadius: 4,
          height: '40px',
        }}
      >
        <MText style={{}}>UID</MText>
        <CButton
          title={CIUtils.padId(myinfo?.id)}
          onClick={() => {
            message.success(t('copied') + '');
          }}
          icon={
            <IconCopy
              size={16}
              color={COLORS.secondary}
              style={{ marginLeft: 5, cursor: 'pointer' }}
            />
          }
          style={{ alignItems: 'center', color: theme.COLORS.textw }}
        />
      </View>

      <Row align={'middle'} style={{ marginTop: 20, gap: 50, width: '100%' }}>
        <Upload
          name="avatar"
          listType="picture-circle"
          className="avatar-uploader"
          showUploadList={false}
          // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
          beforeUpload={beforeUpload}
          onChange={handleUploadChange}
        >
          {imageUrl ? (
            <div
              style={{
                overflow: 'hidden',
                width: '100%',
                height: '100%',
                borderRadius: 9999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                crossOrigin="anonymous"
                src={`${VITE_APP_API_MEDIA_URL}/${imageUrl}`}
                alt="avatar"
                style={{
                  width: '100%',
                }}
              />
            </div>
          ) : (
            uploadButton
          )}
        </Upload>
      </Row>
    </View>
  );
};

export default ProfileEditContainer;

const UploadButton = styled.button`
  border: 0;
  background: none;
  color: ${({ theme }) => theme.COLORS.textw};
`;
